import React from 'react';
import EImg from './EImg';

const ERofl = ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="Face with tears of joy"
		aria-label="Emoji: Face with tears of joy"
		alt="😂"
		src="https://abs.twimg.com/emoji/v2/72x72/1f602.png"
	/>
);

export default ERofl;
